export const LOGIN = "LOGIN";
export const IS_LOGIN = "IS_LOGIN";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const GET_LOGIN_ERRORS = "GET_LOGIN_ERRORS";
